import {Point} from "../Point";
const MAX_STACK_SIZE = 200
export class CrunchDetector {
  constructor(onInitDetect, onCompleteDetect) {
    this.step = 1
    this.onInitDetect = onInitDetect
    this.onCompleteDetect = onCompleteDetect
    this.lastTime = 0

    this.distStack = []
    this.distSum = 0
    this.avg = 0

    this.punchThreshold = null
    this.resetThreshold = null
  }

  mainLoop(head, base) {
    // const dist = Point.dist3D(head.y, base.y)
    const dist = base.y - head.y

    if (this.step === 1) {
      this.distStack.push(dist)
      this.distSum += dist
      if (this.distStack.length > MAX_STACK_SIZE) {
        const remove = this.distStack.shift()
        this.distSum -= remove
      }
      this.avg = this.distSum / this.distStack.length
    }

    const now = new Date().getTime()
    if (this.step === 2) {
      if ((dist < this.avg * this.resetThreshold || dist < 0.15) && now - this.lastTime > 500) {
        this.step = 1
        this.onInitDetect()
        this.lastTime = now
      }
    } else {
      if ((dist > this.avg * this.punchThreshold || dist > 0.35) && now - this.lastTime > 500) {
        this.step = 2
        this.onCompleteDetect()
        this.lastTime = now
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/detector/CrunchDetector.js